export abstract class Entity {
  public abstract update(deltaTime: number): void;

  public abstract render(ctx: CanvasRenderingContext2D): void;
}
